import { breakpoints, Heading } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const TopSection = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    align-items: flex-start;
    margin-top: 4.125rem;
    gap: 4rem;
    margin-bottom: 0rem;
  }
`;

export const DescriptionWrapper = styled('div')`
  order: 1;
  width: 100%;
  margin-bottom: 2.5rem;

  a {
    display: none;
  }

  p {
    display: none;
  }

  @media (min-width: ${breakpoints.md}) {
    order: 2;
    margin-bottom: 0rem;

    a {
      display: inline-block;
      width: auto;
      margin-top: 2rem;
    }

    p {
      display: block;
    }
  }
`;

export const H1 = styled(Heading.H1)`
  font-size: 1.5rem !important;
  line-height: 2rem !important;
  text-align: left;
  margin: 0 !important;

  font-weight: 500 !important;
`;

export const Annotation = styled.span`
  font-size: 0.875rem;
  font-weight: 300;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  line-height: normal;
  display: block;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 1.1rem;
  }
`;

export const Description = styled.p`
  margin-top: 2.5rem;
  line-height: 1.5rem;
  order: 3;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 1rem;
    display: none;
  }
`;

export const VoucherWrapper = styled.div`
  margin-top: 2rem !important;
`;

export const BuyLink = styled('a')<{ fullWidth?: boolean }>`
  background-color: #000;
  padding: 1rem 2rem;
  color: #fff;
  order: 4;
  text-decoration: none;
  text-align: center;
  margin-top: 3.5rem;

  &:hover,
  &:active {
    color: #fff !important;
  }

  display: ${({ fullWidth }) => (fullWidth ? 'block' : 'initial')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'initial')};

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;
